module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.promotions && _vm.promotions.length) ? _c('div', {
    staticClass: "promotion-section__container"
  }, _vm._l((_vm.promotions), function(promotion) {
    return _c('div', {
      ref: 'promotion-' + promotion.id,
      refInFor: true,
      staticClass: "content-section no-margin-top content-section__bordered border-1-20 promotion-section__content"
    }, [_c('div', [_c('div', [_c('div', {
      staticClass: "content-section-title color-1-100 background-1-100-before"
    }, [_c('h3', [_vm._v(_vm._s(promotion.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content-section-text",
      domProps: {
        "innerHTML": _vm._s(promotion.text)
      }
    }), _vm._v(" "), (promotion.link && promotion.button && promotion.link !== '' && promotion.button !== '') ? _c('a', {
      staticClass: "content-section-button border-1-60",
      attrs: {
        "href": promotion.link
      }
    }, [_vm._v("\n          " + _vm._s(promotion.button) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "content-section-image",
      attrs: {
        "alt": promotion.imageAlt,
        "src": _vm.getImageFullPath(promotion.image)
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "content-section-close",
      on: {
        "click": function($event) {
          return _vm.hidePromotion(promotion.id)
        }
      }
    }, [_vm._v("Dismiss info")])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c5faa3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Promotions.vue
// module id = 1006
// module chunks = 0